<template>
	<div class="row">
		<div class="col-12 col-md-4 offset-md-4 mt-5">
			<UpdatePassword/>
		</div>
	</div>
</template>

<script>
import UpdatePassword from '../Widgets/UpdatePassword/UpdatePassword.vue';


export default {
  name: 'Home',
  components: {
    UpdatePassword,
  },
	created() {
		if(this.$cookies.isKey('token')){
			this.$router.push({ name: 'contratos' });
		}
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
